import React, { useState, useEffect } from 'react';
import './Intro.css';
import P from '../../assets/makao.jpeg'
const Intro = () => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });


  useEffect(() => {
    const countDownDate = new Date('Dec 20, 2023 00:00:00').getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setCountdown({ days, hours, minutes, seconds });
    };

    const intervalId = setInterval(updateCountdown, 1000);

    return () => clearInterval(intervalId);
  }, []);

 
 
  return (
    <section id='intro'>
    <div className="landingpage">
      <div className="bg-overlay"></div>

      <div className="home-text">
        <h1>ASTITVA 2023</h1>
        <h3>EXPLORE | EXPRESS | EXCEL | ENJOY</h3><br></br>
        
      </div>

      <div className="launch-time">
                <div>
                    <p id='days'>{countdown.days}</p>
                    <span>Days  </span>
                </div>
                <div>
                    <p id='hours'>{countdown.hours}</p>
                    <span>Hours  </span>
                </div>
                <div>
                    <p id='minutes'>{countdown.minutes}</p>
                    <span>Minutes  </span>
                </div>
                <div>
                    <p id='seconds'>{countdown.seconds}</p>
                    <span>Seconds  </span>
                </div>
            </div>
            <img src={P} alt=' ' className='worksImg'></img>
        <h6>Powered by Makau</h6>
            
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdF9k9xA-LorKQ9r40tIIv4zkvgix3cy68tF-0iyHgY7a9x3Q/viewform" target="_blank" rel="noopener noreferrer">
          <button className='btn' onClick={() => console.log('Button clicked')}>Register</button>
        </a>
        
    </div>
    </section>
  );
};

export default Intro

